import { render } from "./PrizesView.vue?vue&type=template&id=17798c63&scoped=true"
import script from "./PrizesView.vue?vue&type=script&lang=js"
export * from "./PrizesView.vue?vue&type=script&lang=js"

import "./PrizesView.vue?vue&type=style&index=0&id=17798c63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17798c63"]])

export default __exports__